<template>
  <div class="container">
    <video
      class="video"
      src="../../assets/PC官网高分辨率.mp4"
      autoplay
      loop
      muted
    ></video>
    <div class="main">
      <div class="tab_container">
        <div class="logo_icon"></div>
        <div class="login">
          <div class="headset"></div>
          <span @click="login">登录 / 注册</span>
        </div>
      </div>
    </div>
    <div class="wx_dialog">
      <el-dialog
        :visible.sync="wxDialog"
        :show-close="false"
        width="409px"
        @close="close"
      >
        <img
          src="../../assets/扫码弹窗@2x.png"
          alt=""
          width="100%"
          height="100%"
        />
        <div class="code_img">
          <img
            src="../../assets/过期@2x.png"
            alt=""
            @click="getCodeImg"
            class="overdue"
            v-if="autoTimer"
          />
          <img :src="codeImg" alt="" />
        </div>
      </el-dialog>
    </div>
    <div class="login_dialog">
      <el-dialog :visible.sync="loginDialog" :show-close="false" width="409px">
        <div class="login_box">
          <div class="login_head">
            <p>
              亲爱的好声音学院学员，欢迎您使用此站点传歌，使用前请先进行身份登录
            </p>
            <p>
              若您尚未注册好声音学院，登录即视为自动注册
            </p>
          </div>
          <div class="login_body">
            <div
              class="phone_box clearfix"
              :class="{
                border_black: telBorderBlack,
                border_red: telBorderRed
              }"
            >
              <p class="phone_title">
                手机号 <span v-if="telBorderRed">请输入正确手机号</span>
              </p>
              <div class="address">
                中国86+
              </div>
              <div class="tel_box">
                <input
                  :class="{
                    tel_box_black: telBorderBlack,
                    tel_box_red: telBorderRed
                  }"
                  type="text"
                  maxlength="11"
                  v-model="phone"
                  placeholder="请输入手机号"
                  @focus="telFocus"
                  @blur="telBlur"
                />
              </div>
            </div>
            <div class="code_box clearfix">
              <p class="code_title">
                验证码 <span v-if="codeBorderRed">请输入正确验证码</span>
              </p>

              <div
                class="code_num_box"
                :class="{
                  border_black: codeBorderBlack,
                  border_red: codeBorderRed
                }"
              >
                <input
                  type="text"
                  v-model="code"
                  maxlength="6"
                  placeholder="请输入验证码"
                  @focus="codeFocus"
                  @blur="codeBlur"
                />
              </div>

              <div
                @click="getCode"
                class="send_btn"
                :class="hasCode ? 'hasCode' : ''"
              >
                {{ hasCode ? `重新发送（${timeCount}s）` : "获取验证码" }}
              </div>
            </div>
          </div>
          <div class="login_foot">
            <div class="checked_box">
              <el-checkbox class="checked" v-model="checked"></el-checkbox>
              <p>
                我已经阅读并同意<span @click="look"
                  >《好声音学院用户协议》</span
                >
              </p>
            </div>
            <div class="login_btn" @click="jump">
              登录
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
/* eslint-disable */

import { numberCheck } from "../../utils/index";
import {
  qrlogin,
  checkLogin,
  userinfo,
  getTelCode,
  checkTelCode
} from "../../api/index";

export default {
  data() {
    return {
      // 手机号
      phone: "",
      telBorderBlack: false,
      telBorderRed: false,
      //   telDisabled: true,
      // 验证码
      code: "",
      // 是否发送过验证码
      hasCode: false,
      timeCount: 60,
      codeBorderBlack: false,
      codeBorderRed: false,
      wxDialog: false,
      loginDialog: false,
      checked: true,
      codeImg: "",
      loginId: "",
      // 定时器
      timer: "",
      codeToken: "",
      autoTimer: false
    };
  },
  created() {
    this.getCodeImg();
  },
  watch: {
    phone(newVal, oldVal) {
      this.telBorderBlack = true;
      this.telBorderRed = false;
      //   if (numberCheck(newVal)) {
      //     this.telDisabled = false;
      //   } else {
      //     this.telDisabled = true;
      //   }
    },
    code(newVal, oldVal) {
      this.codeBorderBlack = true;
      this.codeBorderRed = false;
    }
  },
  mounted() {},
  methods: {
    close() {
      clearInterval(this.timer);
    },
    look() {
      window.open("/agreement");
    },
    async getCodeImg() {
      // 获取登录二维码
      if (window.localStorage.getItem("loginId")) {
        this.loginId = window.localStorage.getItem("loginId");
      }
      let res = await qrlogin(this.loginId);
      this.codeImg = res.data.qrCode;
      this.loginId = res.data.loginId;
      if (this.autoTimer) {
        this.login();
      }
      this.autoTimer = false;
      window.localStorage.setItem("loginId", this.loginId);
    },
    // 登录注册
    login() {
      this.wxDialog = true;
      let count = 0;
      this.timer = setInterval(() => {
        count++;
        this.checkSweepCode();
        if (count > 45) {
          this.autoTimer = true;
          clearInterval(this.timer);
          count = 0;
        }
      }, 1000);
      //   this.checkSweepCode();
    },
    // 轮训扫码登录
    async checkSweepCode() {
      let res = await checkLogin(this.loginId);
      if (res.data.message == "登录成功") {
        window.localStorage.setItem("token", res.data.token);
        window.localStorage.removeItem("loginId");
        this.wxDialog = false;
        clearInterval(this.timer);
        this.getuserInfo();
      }
    },
    // 获取用户信息
    async getuserInfo() {
      let res = await userinfo();
      window.localStorage.setItem("userInfo", JSON.stringify(res.data.data));
      if (
        res.data.data.mobilePhone == "" ||
        res.data.data.mobilePhone == null
      ) {
        this.loginDialog = true;
      } else {
        window.location.href = "/";
      }
    },
    // 手机号码获取焦点事件
    telFocus() {
      this.telBorderBlack = true;
    },
    // 手机号码失去焦点事件
    telBlur() {
      if (numberCheck(this.phone)) {
        this.telBorderBlack = true;
        this.telBorderRed = false;
      } else {
        this.telBorderRed = true;
      }
    },
    // 验证码获取焦点事件
    codeFocus() {
      this.codeBorderBlack = true;
    },
    // 验证码失去焦点事件
    codeBlur() {
      //   this.codeBorderRed = true;
    },
    // 获取验证码
    async getCode() {
      if (!this.hasCode) {
        if (numberCheck(this.phone)) {
          this.hasCode = true;
          let res = await getTelCode({ mobilePhone: this.phone });
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "验证码已发送,请注意查看手机信息~"
            });
            this.codeToken = res.data.data.token;
          }
          let timer = setInterval(() => {
            this.timeCount--;
            if (this.timeCount == 0) {
              clearInterval(timer);
              this.timeCount = 60;
              this.hasCode = false;
            }
          }, 1000);
        } else {
          this.telBorderRed = true;
          this.$message({
            type: "error",
            message: "请填写正确的手机号"
          });
        }
      }
    },
    async jump() {
      if (numberCheck(this.phone)) {
        if (this.code !== "") {
          this.$openLoading();
          let res = await checkTelCode({
            token: this.codeToken,
            mobilePhone: this.phone,
            code: this.code
          });
          if (res.data.success) {
            this.$closeLoading();
            window.location.href = "/";
            // this.$router.push({ path: "/" });
          } else {
            this.$closeLoading();
            this.codeBorderRed = true;
            this.$message({
              type: "error",
              message: "验证码错误"
            });
          }
        } else {
          this.codeBorderRed = true;
          this.$message({
            type: "error",
            message: "验证码错误"
          });
        }
      } else {
        this.telBorderRed = true;
        this.$message({
          type: "error",
          message: "请填写正确的手机号"
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  overflow: hidden;
  .video {
    object-fit: fill;
    width: auto;
    height: auto;
    min-width: 100%;
    min-height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .main {
    position: relative;
    z-index: 9;
    .tab_container {
      width: 100%;
      height: 80px;
      padding: 20px 131px 0;
      .logo_icon {
        width: 166px;
        height: 40px;
        background: url("../../assets/jlt_pc.png") no-repeat;
        background-size: 535px 314px;
        background-position: -29px -25px;
        float: left;
      }
      .login {
        float: right;
        height: 40px;
        line-height: 40px;
        text-align: right;
        .headset {
          width: 28px;
          height: 28px;
          background: url("../../assets/jlt_pc.png") no-repeat;
          background-size: 535px 314px;
          background-position: -228px -31px;
          float: left;
          margin-top: 6px;
        }
        span {
          font-size: 20px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          padding-left: 40px;
          cursor: pointer;
        }
      }
    }
  }
  .wx_dialog {
    position: relative;
    .code_img {
      width: 240px;
      height: 240px;
      background-color: #fff;
      position: absolute;
      top: 160px;
      left: 50%;
      transform: translateX(-50%);
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
      .overdue {
        position: absolute;
        top: 0;
      }
    }
  }
  .wx_dialog /deep/ .el-dialog__header {
    padding: 0;
    height: 0;
  }
  .wx_dialog /deep/ .el-dialog {
    background-color: transparent;
    border-radius: 8px;
  }

  .wx_dialog /deep/.el-dialog__body {
    padding: 0;
    background-color: transparent;
    border-radius: 8px;
  }
  .login_dialog {
    .login_box {
      width: 407px;
      height: 560px;
      background: rgba(254, 255, 254, 1);
      border-radius: 8px;
      padding: 40px 20px;
      .login_head {
        :nth-child(1) {
          font-size: 14px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 500;
          color: rgba(38, 33, 33, 1);
        }
        :nth-child(2) {
          font-size: 14px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: rgba(179, 175, 175, 1);
          margin-top: 5px;
        }
      }
      .login_body {
        width: 100%;
        .phone_box {
          width: 100%;
          margin-top: 32px;
          border-bottom: 1px solid rgba(230, 230, 230, 1);
          .phone_title {
            font-size: 26px;
            font-family: SourceHanSansCN-Medium, SourceHanSansCN;
            font-weight: 500;
            color: rgba(38, 33, 33, 1);
            span {
              font-size: 14px;
              font-family: SourceHanSansCN-Normal, SourceHanSansCN;
              font-weight: 400;
              color: rgba(179, 175, 175, 1);
            }
          }
          .address {
            float: left;
            font-size: 16px;
            font-family: SourceHanSansCN-Medium, SourceHanSansCN;
            font-weight: 500;
            color: rgba(38, 33, 33, 1);
            margin-top: 28px;
            margin-bottom: 16px;
          }
          .tel_box {
            float: left;
            margin-top: 26px;
            margin-left: 19px;
            input {
              border: 0px;
              outline: none;
              font-size: 16px;
              font-family: SourceHanSansCN-Medium, SourceHanSansCN;
              font-weight: 500;
              color: rgba(38, 33, 33, 1);
              //   cursor: pointer;
            }
            .tel_box_black {
              color: rgba(38, 33, 33, 1);
            }
            .tel_box_red {
              color: rgba(255, 64, 64, 1);
            }
          }
        }
        .code_box {
          width: 100%;
          margin-top: 32px;
          .code_title {
            font-size: 26px;
            font-family: SourceHanSansCN-Medium, SourceHanSansCN;
            font-weight: 500;
            color: rgba(38, 33, 33, 1);
            span {
              font-size: 14px;
              font-family: SourceHanSansCN-Normal, SourceHanSansCN;
              font-weight: 400;
              color: rgba(179, 175, 175, 1);
            }
          }

          .code_num_box {
            float: left;
            margin-top: 26px;
            padding-bottom: 16px;
            border-bottom: 1px solid rgba(230, 230, 230, 1);

            input {
              border: 0px;
              outline: none;
              font-size: 16px;
              font-family: SourceHanSansCN-Medium, SourceHanSansCN;
              font-weight: 500;
              color: rgba(38, 33, 33, 1);
              //   cursor: pointer;
            }
          }
          .send_btn {
            float: right;
            width: 140px;
            height: 36px;
            margin-top: 28px;
            padding: 0;
            border-radius: 10px;
            background: rgba(255, 64, 64, 1);
            line-height: 36px;
            text-align: center;
            font-size: 15px;
            font-family: SourceHanSansCN-Medium, SourceHanSansCN;
            font-weight: 500;
            color: rgba(254, 255, 254, 1);
            cursor: pointer;
          }
          .hasCode {
            background: rgba(240, 240, 240, 1);
            color: rgba(204, 204, 204, 1);
          }
        }
      }
      .login_foot {
        margin-top: 55px;
        padding: 0 10px;
        .checked_box {
          .checked {
            float: left;
            margin-right: 7px;
          }
          p {
            font-size: 11px;
            font-family: SourceHanSansCN-Normal, SourceHanSansCN;
            font-weight: 400;
            color: rgba(179, 175, 175, 1);
            line-height: 20px;
            span {
              font-size: 11px;
              font-family: SourceHanSansCN-Medium, SourceHanSansCN;
              font-weight: 500;
              color: rgba(255, 64, 64, 1);
              cursor: pointer;
            }
          }
        }
        .login_btn {
          width: 100%;
          height: 57px;
          background: rgba(255, 64, 64, 1);
          border-radius: 10px;
          margin-top: 18px;
          line-height: 57px;
          text-align: center;
          font-size: 21px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 500;
          color: rgba(254, 255, 254, 1);
          cursor: pointer;
        }
      }
    }
  }
  .login_dialog /deep/ .el-dialog__header {
    padding: 0;
    height: 0;
  }
  .login_dialog /deep/ .el-dialog {
    background-color: transparent;
    border-radius: 8px;
  }
  .login_dialog /deep/.el-dialog__body {
    padding: 0;
    background-color: transparent;
    border-radius: 8px;
  }
}
// 黑边
.border_black {
  border-bottom: 1px solid rgba(38, 33, 33, 1) !important;
}
// 红边
.border_red {
  border-bottom: 1px solid rgba(255, 64, 64, 1) !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue